import { SupportedDateParts } from "../../utils/date-format-parts.js";
const deserializeDate = (value) => {
  if (!value) {
    return {
      [SupportedDateParts.YEAR]: "",
      [SupportedDateParts.MONTH]: "",
      [SupportedDateParts.DAY]: ""
    };
  }
  const [year, month, day] = value.split("-");
  return {
    [SupportedDateParts.YEAR]: year,
    [SupportedDateParts.MONTH]: month ? String(parseInt(month, 10)) : "",
    [SupportedDateParts.DAY]: day ? String(parseInt(day, 10)) : ""
  };
};
function serializeDate(value, datePart, currentDate) {
  const newYear = datePart === SupportedDateParts.YEAR ? value : currentDate[SupportedDateParts.YEAR];
  const newMonth = datePart === SupportedDateParts.MONTH ? value : currentDate[SupportedDateParts.MONTH];
  const newDay = datePart === SupportedDateParts.DAY ? value : currentDate[SupportedDateParts.DAY];
  const yearFormatted = newYear || "";
  const monthFormatted = newMonth ? newMonth.padStart(2, "0") : "";
  const dayFormatted = newDay ? newDay.padStart(2, "0") : "";
  return [yearFormatted, monthFormatted, dayFormatted].join("-");
}
function getFocusFieldId(id, datePart) {
  return `${id}/${datePart}`;
}
export {
  deserializeDate,
  getFocusFieldId,
  serializeDate
};
//# sourceMappingURL=helpers.js.map
